import React, { Component,useState } from 'react';
import { Show, List, TabbedShowLayout, Tab, Datagrid,BooleanField, EditButton, TextField, ReferenceField, ReferenceManyField, DateField, TopToolbar, RefreshButton, ListButton,usePermissions,useTranslate } from 'react-admin';
import { CamelCaseField, ExpectedDateField } from '../digitalOrders/common';
import { Scrollbars } from 'react-custom-scrollbars';
import { getLocalStorageKey, CommonHeaderOption, RUN_TIME_API_ENDPOINT } from '../common/common';
import { useLocation } from 'react-router-dom';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
    display: 'block',
    width: 400,
    // overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'break-spaces'
};

const ShowActions = ({ basePath, data }) => (
    <TopToolbar>
        <RefreshButton />
        <ListButton basePath={basePath} />
    </TopToolbar>
)

const ShowTitle = ({ record }) => {
    const translate = useTranslate();

    return record && <span>{translate('resources.send_sms_bulk_notifications.fields.bulk_msg_details')} {record.name}</span>;
};

const BulkSendMessageShow = (props) => {

    const [loadingShow, setLoadingShow] = useState(false);
    const permissions = usePermissions();
    const translate = useTranslate();
    const location = useLocation();
    const pathSplit = location.pathname.split('/');
    const bulkSmsMessageId = pathSplit[2]

    
        // const { props, permissions, state } = this;
        // console.log('xxxx',state.soldToList);
    return (
        <Show actions={<ShowActions permissions={permissions} />} {...props} title={<ShowTitle />}>
        <TabbedShowLayout className="tab-scroll">
            <Tab label={translate('resources.send_sms_bulk_notifications.fields.details')} sort={{ field: 'created_at', order: 'DESC' }}  contentClassName="scrollTab">
                <TextField  source="purpose" allowEmpty />
                <TextField  source="job_status" />
                <TextField  source="admin_name" />
                <TextField  source="admin_email" />
                <TextField  source="targeted_businesses_count" allowEmpty />
                <TextField  source="notified_businesses_count" allowEmpty />
                <TextField  source="notification_read_count" allowEmpty />
                <TextField  source="send_status_percent" allowEmpty />
                {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                <DateField  source="created_at" showTime />
            </Tab>
            <Tab label={translate('resources.send_sms_bulk_notifications.fields.sold_list')}>
                <ReferenceManyField
                    label=""
                    reference="send_sms_bulk_sold_to_list"
                    target="id"
                    className="tab-pagination"
                >
                    <List
                    actions={false}
                    filterDefaultValues={{ id: bulkSmsMessageId }} 
                    hasCreate={false}
                    exporter={false}>
                        <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                            <TextField  source="name" />
                            <TextField  source="sold_to_id" />
                            <TextField source="name" />
                            <TextField source="phone" />
                            <TextField   style={textFieldStyle}  source="sms_text" />
                            <BooleanField source="send_status" />
                            <TextField  source="send_response" />
                        </Datagrid>
                    </List>
                </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
        </Show>
        );
    
}

export default BulkSendMessageShow;